import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from "../../services/tutorial.service";
import Demo from "../crop/Demo";
import moment from "moment";
import $ from "jquery";
import { playerdefaultLogo } from "../../constants/Images";
import { logUser } from "../../actions";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from '../utils/Demo';
import { useHistory, useParams } from "react-router-dom";
import { BASE_PATH } from "../../constants/Global";

function Editprofile(match) {
  const getpageData = useSelector((state) => state.setUserlog);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  const aid = localStorage.getItem("auction_id");
  const [croppedImage, setCroppedImage] = useState("");
  const [defimg, setdefimg] = useState(playerdefaultLogo);
  const history = useHistory({ forceRefresh: true });

  let logo_pic = "";

  const onSubmit = (values) => {
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid ,token: token}]),
      },
    };
    values["logo_pic"] = croppedImage;
    DataService.editProfile(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        //  console.log("responseeeeeeeee");
        //  console.log(response);

        if (response.success == true) {
          let resData = response.data;

          let logUserdata = {
            cid: getpageData.cid,
            city: resData.city,
            cperson: resData.cperson,
            emailid: resData.emailid,
            mobno: getpageData.mobno,
            photo: resData.photo,
            token: getpageData.token,
          };

          dispatch(logUser(logUserdata));
          localStorage.setItem("user", JSON.stringify(new Array(logUserdata)));
          history.push(BASE_PATH + "my-profile");

          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };

  useEffect(() => {
    //  console.log(getpageData, "getpageData", localStorage.getItem("user"));
    setValue("cperson", getpageData.cperson);
    setValue("city", getpageData.city);
    setValue("emailid", getpageData.emailid);
    setdefimg(getpageData.photo ? getpageData.photo : playerdefaultLogo)

    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });


    // $(".crop-default img").attr(
    //   "src",
    //   getpageData.photo ? getpageData.photo : playerdefaultLogo
    // );
  }, [Demo]);

  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label htmlFor="crop-pic">
                                    {" "}
                                    Profile Pic{/*logo*/}{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <div style={{ clear: "both" }}></div>
                                  {/* <Demo /> */}
                                  {localStorage.getItem('crp_typ') == 0 ?
                                    <ImageCropper2
                                      defaultImage={defimg}
                                      setCroppedImage={setCroppedImage}
                                    /> :
                                    <ImageCropper1
                                      croppedImage={croppedImage}
                                      defaultimage={defimg}
                                      setCroppedImage={setCroppedImage}
                                    />
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="cperson"> Name * </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register("cperson", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.name && (
                                    <p className="text-error">
                                      {errors.cperson.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="city"> City * </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register("city", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.city && (
                                    <p className="text-error">
                                      {errors.city.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="emailid"> Email Id * </label>
                                </div>
                                <div className="col-md-6">
                                  <input
                                    className="form-control"
                                    type="email"
                                    {...register("emailid", {
                                      required: true,
                                      required: "required field.",
                                      pattern: {
                                        value: /\S+@\S+\.\S+/,
                                        message: "Not match email format"
                                    }
                                    })}
                                  />
                                  {errors.emailid && (
                                    <p className="text-error">
                                      {errors.emailid.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button"
                                type="submit"
                                style={{ borderRadius: "8px", marginLeft:'15px' }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editprofile;
